export const validateEndDate = (start, end, errorMessage) => {
    if (start <= end) {
        return Promise.resolve();
    } else {
        return Promise.reject(new Error(errorMessage || "End date must be greater than start date."));
    }
}

export const dataDate = (date) => {
    let timestamp = new Date(date).getTime();
    let todate = new Date(timestamp).getDate();
    let tomonth = new Date(timestamp).getMonth() + 1;
    let toyear = new Date(timestamp).getFullYear();
    let original_date = tomonth + '/' + todate + '/' + toyear;
    return original_date
}